import React from "react";

import type { PaperProps } from "@mui/material";
import type { SerializedStyles } from "@emotion/react";

import SubHeaderFilled, { SubHeaderFilledPropsT } from "components/PlatformLayout/components/SubHeaderFilled";
import Spinner from "components/LoadingElements/Spinner";

import * as S from "./styles";

type BasicCardPropsT = PaperProps & {
  headerProps?: SubHeaderFilledPropsT;
  refElement?: React.ReactNode; // for auto scrolling location
  cardStyleOverrides?: SerializedStyles | SerializedStyles[] | React.CSSProperties | undefined;
  subSectionContent?: React.ReactNode;
  subSectionStyles?: SerializedStyles | SerializedStyles[] | React.CSSProperties | undefined;
  loading?: boolean;
};

const BasicCard = ({
  children,
  headerProps,
  cardStyleOverrides = undefined,
  loading,
  refElement,
  subSectionContent,
  subSectionStyles,
  ...rest
}: BasicCardPropsT) => {
  return (
    <>
      {refElement}
      {headerProps?.title && <SubHeaderFilled {...headerProps} />}
      {subSectionContent && <S.SubSection css={subSectionStyles}>{subSectionContent}</S.SubSection>}
      <S.StyledPaper css={cardStyleOverrides} header={Boolean(headerProps)} {...rest}>
        {loading && <Spinner loading noMask />}
        {children}
      </S.StyledPaper>
    </>
  );
};

export type { BasicCardPropsT };

export default BasicCard;
